import { Injectable } from '@angular/core';
import { ApiConfigService } from '../../../shared-services/api-config.service';
import { UserDataService } from '../data-storage/user-data.service';
import { AuthServiceService } from '../../../shared-services/auth-service.service';
import { SignUpDto } from '../../../dtos/signUpDto';
import { FormGroup } from '@angular/forms';
import { UserDto } from '../../../dtos/userDto';
import { MonumentDto } from '../../../dtos/monumentDto';
import { SiteDto } from '../../../dtos/siteDto';

@Injectable({
    providedIn: 'root'
})
export class UserService {

    constructor(private apiConfigService: ApiConfigService,
                private userDataService: UserDataService,
                private authService: AuthServiceService) {
    }

    saveFavoriteSite(site: SiteDto): void {
        let user = this.userDataService.getUser();
        const foundIndex = user.favoriteSites.findIndex((el) => el == site.id);
        if (foundIndex > -1) {
            user.favoriteSites.splice(foundIndex, 1);
        } else {
            user.favoriteSites.push(site.id);
        }
        this.userDataService.setUser(user);
        this.apiConfigService.get('api/user/favorite', {siteId: site.id})
            .subscribe();
    }

    saveFavoriteMonument(monument: MonumentDto): void {
        let user = this.userDataService.getUser();
        const foundIndex = user.favoriteMonuments.findIndex((el) => el == monument.id);
        if (foundIndex > -1) {
            user.favoriteMonuments.splice(foundIndex, 1);
        } else {
            user.favoriteMonuments.push(monument.id);
        }
        this.userDataService.setUser(user);
        this.apiConfigService.get('api/user/favorite', {monumentId: monument.id})
            .subscribe();
    }

    logout() {
        sessionStorage.removeItem("tokenType");
        sessionStorage.removeItem("accessToken");
        this.userDataService.setUser(new UserDto());
    }

    validateUser(signInDto) {
        let notAuthenticated = false;
        return this.authService.authenticate(signInDto)
            .toPromise()
            .then((data: any) => {
                sessionStorage.setItem('tokenType', data.tokenType);
                sessionStorage.setItem('accessToken', data.accessToken);
                return this.authService.getMe()
                    .toPromise()
                    .then((user) => {
                        const isValidRemoteUser = user.roles.find((el) => el.name === 'ROLE_REMOTE');
                        if (isValidRemoteUser) {
                            notAuthenticated = false;
                            this.userDataService.setUser(user);
                        } else {
                            sessionStorage.removeItem('tokenType');
                            sessionStorage.removeItem('accessToken');
                            notAuthenticated = true;
                        }
                        return notAuthenticated;
                    }, error2 => {
                        this.logout();
                        return notAuthenticated = true;
                    })
            }, error2 => {
                this.logout();
                return notAuthenticated = true;
            });
    }

    signUp(signUpDto: SignUpDto) {
        return this.authService.signUp(signUpDto);
    }

    updateMe(user: UserDto) {
        return this.apiConfigService.post('api/user/update/me', user);
    }

    updatePassword(passwordMap: Record<string, string>) {
        return this.apiConfigService.post('api/auth/changePassword', passwordMap);
    }

    getOrders() {
        return this.apiConfigService.get('api/order');
    }

    deleteMe() {
        return this.apiConfigService.get('api/user/delete/me');
    }

}
